import store from 'app-store';
import { SET, CLEAR_PAGE_DATA, UPDATE_PURCHASE_ORDER } from './action-types';

// Action creators
export function set(data) {
  store.dispatch({
    type: SET,
    data
  });
}

export function clearPageData() {
  store.dispatch({
    type: CLEAR_PAGE_DATA
  });
}

export function updatePurchaseOrder(purchaseOrder) {
  store.dispatch({
    type: UPDATE_PURCHASE_ORDER,
    purchaseOrder
  });
}
